// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2esGl","rootSuccess":"CompleteLink_rootSuccess__1qcPr","rootFailure":"CompleteLink_rootFailure__1TI2U","isDisabled":"CompleteLink_isDisabled__U7zUL"};